import {IHttpTransport} from './types';

export class FetchTransport implements IHttpTransport {
    async post(url: string, body: unknown, headers: Record<string, string>): Promise<unknown> {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(body),
        });
        return response.json();
    }
}
